import axios from '@/axios/fetch';
import { definitions } from '@/types/api';
/** confgi.services 配置项services */
const configService = () => {
  /** 根据用户id查询实验类型次数 */
  const listStuCaseNumber = async (): Promise<{[index: string]: definitions['ExperimentCaseModuleCountResponse'][]}> => {
    const { data } = await axios.post('./api/experimentOperating/queryCaseModuleCount');
    return data.data;
  };

  return {
    listStuCaseNumber,
  };
};

export default configService;
